import React, { useEffect, useRef, useState } from 'react';
import Container from '../../../constants/Container';
import InputTextBox from '../../../constants/InputTextBox';
import { Grid } from '@mui/material'
import SelectInputBox from '../../../constants/SelectInputBox';
import SecHeading from '../../../constants/SecHeading';
import NepaliInputBox from '../../../constants/NepaliInputBox';
import { Button } from '../../../constants/Button';
import { MdOutlinePhone } from "react-icons/md";
import { CiCalendarDate } from "react-icons/ci";
import { CiLocationOn } from "react-icons/ci";
import { PiIslandLight, PiNumberCircleNineThin } from "react-icons/pi";
import { FiUser } from "react-icons/fi";
import { IoDocumentsOutline, IoPeopleCircleOutline } from "react-icons/io5";
import { GiAscendingBlock, GiPathDistance } from 'react-icons/gi';
import { TbHexagonNumber2 } from "react-icons/tb";
import { useFormik } from 'formik';
import { postDataToTheServer } from '../../../helpers/api';
import AppURL from '../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../constants/Toast';
import { handleChangeDate, handleChangePhone, handleNepaliInputChange, handleSelectBox } from '../../../helpers/handleChange';
import { AppSpace, EndBaseLine } from '../../../constants/AppSpace';
import { CasteOptions, DistrictOptions, GenderOptions, MemberTypeOptions, MeterStatusOptions, MeterTypeOptions, MunicipalityOptions, ProvinceOptions, ReaderOptions, TapSizeOptions, TapStatusOptions, TapTypeOptions, ToleOptions, YesNoOptions } from '../../../constants/Options';
import { Caste, District, Province, Reader, TapSize, Tole } from '../../../helpers/models/Models';
import useFetchSubData from '../../../helpers/useSubFetch';
import FileTextBox from '../../../constants/FileTextBox';
import { customerValidationSchema } from '../../../helpers/validation';
import EMIFormView from './widgets/EMIFormView';

interface AuthorTableListViewProps {
    data: {
        message: string;
        member_sn: number;
        province: Province[];
        tap_size: TapSize[];
        tole: Tole[];
        caste: Caste[];
        district: District[];
        reader: Reader[];
    } | null;
    refetch: () => void;
    loading: boolean;
    error: string | null;
}
const ConsumerAddFormView: React.FC<AuthorTableListViewProps> = ({ data, refetch, loading, error }) => {
    const fileInputRefs = useRef<Record<string, HTMLInputElement | null>>({});

    const initialValues = {
        mem_name: "",
        mem_name_nep: "",
        spouse_name: "",
        spouse_name_nep: "",
        municipality: "",
        add_nep: "",
        add_eng: "",
        ward_no: "",
        district: "",
        sms_mob_no: "",
        phone_no: "",
        dob: "",
        ctiz_no: "",
        ctiz_issue_district: "",
        province: "",
        gender: "",
        caste: "",
        pan_no: "",
        family_male_no: "",
        family_female_no: "",
        father_name: "",
        father_name_nep: "",
        grand_father_name: "",
        grand_father_name_nep: "",
        old_sys_no: "",
        reg_date_n: "",
        meter_conn_date: "",
        marga_tole: "",
        meter_reading_zone: "",
        serial_no: "",
        serial_suffix: "",
        area_no: "",
        meter_status: "",
        customer_type: "",
        tap_type: "",
        tap_no: "",
        discount_unit: "",
        reader: "",
        reading_day: "",
        meter_type: "",
        meter_sn: "",
        reading_effective: "",
        consumers_no: "",
        emi: "",
        tap_status: "",
        nak_sa_no: "",
        kitta_no: "",
        area_land: "",
        purja_no: "",
        house_no: "",
        sadhiyar_no: "",
        branch: 1,
        block_no: "",
        area_supply: "",
        tap_size: "",
        ferrule_meter_distance: "",
        ground_level_ferrule: "",
        distance: "",
        mian_pipe_size: "",
        photo: "",
        citz_photo: "",
        thumb_photo: "",
        signature1: "",
        lal_purja: "",
    };
    const { values, errors, touched, setFieldValue, handleBlur, handleChange, handleSubmit } =
        useFormik({
            initialValues,
            validationSchema: customerValidationSchema,
            onSubmit: async (values, action) => {
                const formData = new FormData();
                Object.keys(values).forEach((key) => {
                    const value = (values as Record<string, any>)[key];
                    if (value !== undefined && value !== null && value !== "") {
                        formData.append(key, value);
                    }
                });
                try {
                    await postDataToTheServer(AppURL.FrontOfficeURL + "front-customer-create-list-view/", formData).then((res) => {
                        if (res?.status === 201) {
                            ToastSuccess({ message: res?.message });
                            clearFileInputs();
                            action.resetForm();
                            refetch();
                        } else if (res?.status === 400) {
                            ToastWarning(res?.message);
                        } else {
                            // ToastError("Something Error")
                        }
                    });
                } catch (error) {
                    console.log(error);
                }
            },
        });
    const clearFileInputs = () => {
        Object.keys(fileInputRefs.current).forEach((key) => {
            if (fileInputRefs.current[key]) {
                fileInputRefs.current[key]!.value = '';
            }
        });
    };
    const toleOptions = ToleOptions(data?.tole);
    const provinceOptions = ProvinceOptions(data?.province);
    const tapSizeOptions = TapSizeOptions(data?.tap_size);
    const casteOptions = CasteOptions(data?.caste);
    const districtOptions = DistrictOptions(data?.district);
    const readerOptions = ReaderOptions(data?.reader);
    const { data: district_list, loading: district_loading, error: district_error } = useFetchSubData(AppURL.FrontOfficeURL + 'province/wise/district/municipality/options/list/?province_id=' + values.province, values.province);
    const districtListOptions = DistrictOptions(district_list?.province);

    const { data: municipality_list, loading: municipality_loading, error: municipality_error } = useFetchSubData(AppURL.FrontOfficeURL + 'province/wise/district/municipality/options/list/?district_id=' + values.district, values.district);
    const municipalityListOptions = MunicipalityOptions(municipality_list?.district);
    const [emiOpen, setOnEmi] = useState({ open: false, member_sn: data?.member_sn || 1 });
    useEffect(() => {
        setOnEmi((prevState) => ({ ...prevState, member_sn: data?.member_sn || 1 }));
    }, [data?.member_sn]);
    
    return (
        <Container padding={true}>
            <EMIFormView emiOpen={emiOpen} setOnEmi={setOnEmi} />
            <form onSubmit={handleSubmit} encType="multipart/form-data">
                <SecHeading type='add' label='Consumer Add' />
                <Grid container columnSpacing={2} rowSpacing={0.5}>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<FiUser />}
                            name='mem_name'
                            label='Member Name'
                            handleChange={handleChange}
                            value={values.mem_name}
                            error={errors.mem_name}
                            handleBlur={handleBlur}
                            required={true}
                            placeholder='Enter Member Name'
                            touched={touched.mem_name}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <NepaliInputBox
                            label='Member Name(Nepali)'
                            name='mem_name_nep'
                            value={values.mem_name_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'mem_name_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            placeholder='Enter Member Name(Nepali)'
                            error={errors.mem_name_nep}
                            touched={touched.mem_name_nep}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<IoPeopleCircleOutline />}
                            label="Spouse's Name"
                            name='spouse_name'
                            handleChange={handleChange}
                            value={values.spouse_name}
                            error={errors.spouse_name}
                            handleBlur={handleBlur}
                            touched={touched.spouse_name}
                            placeholder='Enter Spouse Name'
                            required={true}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <NepaliInputBox
                            label="Spouse's Name(Nepali)"
                            name='spouse_name_nep'
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'spouse_name_nep' })}
                            value={values.spouse_name_nep}
                            error={errors.spouse_name_nep}
                            handleBlur={handleBlur}
                            touched={touched.spouse_name_nep}
                            placeholder="Spouse's Name(Nepali)"
                            required={true} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<CiLocationOn />}
                            label="Address"
                            name='add_eng'
                            handleChange={handleChange}
                            value={values.add_eng}
                            error={errors.add_eng}
                            handleBlur={handleBlur}
                            touched={touched.add_eng}
                            placeholder="Enter Address"
                            required={true}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <NepaliInputBox
                            label="Address(Nepali)"
                            name='add_nep'
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'add_nep' })}
                            value={values.add_nep}
                            error={errors.add_nep}
                            handleBlur={handleBlur}
                            touched={touched.add_nep}
                            placeholder='Enter address(Nepali)'
                            required={true} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            prefix={<PiNumberCircleNineThin />}
                            label='Ward No.'
                            name='ward_no'
                            handleChange={handleChange}
                            value={values.ward_no}
                            error={errors.ward_no}
                            handleBlur={handleBlur}
                            touched={touched.ward_no}
                            placeholder='00'
                            required={true} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<MdOutlinePhone />}
                            name='phone_no'
                            handleChange={(e) => handleChangePhone(e, { setFieldValue, name: 'phone_no' })}
                            handleBlur={handleBlur}
                            value={values.phone_no}
                            error={errors.phone_no}
                            touched={touched.phone_no}
                            placeholder='XXX-XXXXXXX'
                            label='Phone Number'
                            required={true}
                        />

                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<MdOutlinePhone />}
                            label='SMS Mobile No.'
                            name='sms_mob_no'
                            handleChange={(e) => handleChangePhone(e, { setFieldValue, name: 'sms_mob_no' })}
                            handleBlur={handleBlur}
                            value={values.sms_mob_no}
                            error={errors.sms_mob_no}
                            touched={touched.sms_mob_no}
                            placeholder='XXX-XXXXXXX'
                            required={true}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<CiCalendarDate />}
                            handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'dob' })}
                            label='DOB(BS)'
                            name='dob'
                            handleBlur={handleBlur}
                            value={values.dob}
                            error={errors.dob}
                            touched={touched.dob}
                            placeholder='XXXX/XX/XX'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Citizenship No.'
                            name='ctiz_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.ctiz_no}
                            error={errors.ctiz_no}
                            touched={touched.ctiz_no}
                            placeholder='000-000-0'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='Province'
                            options={provinceOptions}
                            optionSelect={(name, selectedOption) => {
                                setFieldValue('district', '');
                                setFieldValue("municipality", '');
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            isLoading={loading}
                            value={values.province}
                            required={false}
                            placeholder='Select province'
                            name='province'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'province' } });
                            }}
                            touched={touched.province}
                            errors={errors.province}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='District'
                            options={districtListOptions}
                            optionSelect={(name, selectedOption) => {
                                setFieldValue("municipality", '');
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            isLoading={district_loading}
                            required={false}
                            placeholder='Select district'
                            name='district'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'district' } });
                            }}
                            value={values.district}
                            touched={touched.district}
                            errors={errors.district}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='Municipality'
                            options={municipalityListOptions}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            isLoading={municipality_loading}
                            required={false}
                            placeholder='Select municipality'
                            name='municipality'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'municipality' } });
                            }}
                            value={values.municipality}
                            touched={touched.municipality}
                            errors={errors.municipality}
                        />
                    </Grid>

                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='Citizenship Issue District'
                            options={districtOptions}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            required={false}
                            placeholder='Select District'
                            name='ctiz_issue_district'
                            isLoading={loading}
                            handleBlur={() => {
                                handleBlur({ target: { name: 'ctiz_issue_district' } });
                            }}
                            value={values.ctiz_issue_district}
                            touched={touched.ctiz_issue_district}
                            errors={errors.ctiz_issue_district}
                        />
                    </Grid>

                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='Gender'
                            options={GenderOptions}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            required={false}
                            placeholder='Select Gender'
                            name='gender'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'gender' } });
                            }}
                            value={values.gender}
                            touched={touched.gender}
                            errors={errors.gender}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='Caste'
                            options={casteOptions}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            isLoading={loading}
                            required={false}
                            placeholder='Select Caste'
                            name='caste'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'caste' } });
                            }}
                            value={values.caste}
                            touched={touched.caste}
                            errors={errors.caste}
                        />

                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Pan No.'
                            name='pan_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.pan_no}
                            error={errors.pan_no}
                            touched={touched.pan_no}
                            placeholder='000-000'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Family Male No.'
                            name='family_male_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.family_male_no}
                            error={errors.family_male_no}
                            touched={touched.family_male_no}
                            placeholder='0'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Family Female No.'
                            name='family_female_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.family_female_no}
                            error={errors.family_female_no}
                            touched={touched.family_female_no}
                            placeholder='0'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox type='text'
                            label='Father Name'
                            name='father_name'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.father_name}
                            error={errors.father_name}
                            touched={touched.father_name}
                            placeholder='Enter father name'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <NepaliInputBox
                            label='Father Name(Nepali)'
                            name='father_name_nep'
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'father_name_nep' })}
                            value={values.father_name_nep}
                            error={errors.father_name_nep}
                            handleBlur={handleBlur}
                            placeholder='Enter father name(nepali)'
                            touched={touched.father_name_nep}
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox type='text'
                            label='Grandfather Name'
                            name='grand_father_name'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.grand_father_name}
                            error={errors.grand_father_name}
                            touched={touched.grand_father_name}
                            placeholder='Enter Grandfather name'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <NepaliInputBox
                            label='Grandfather Name(Nepali)'
                            name='grand_father_name_nep'
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'grand_father_name_nep' })}
                            value={values.grand_father_name_nep}
                            error={errors.grand_father_name_nep}
                            handleBlur={handleBlur}
                            touched={touched.grand_father_name_nep}
                            placeholder='Enter Grandfather Name(Nepali)'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<PiNumberCircleNineThin />}
                            label='Old System No'
                            name='old_sys_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.old_sys_no}
                            error={errors.old_sys_no}
                            touched={touched.old_sys_no}
                            placeholder='SYS-001'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<PiNumberCircleNineThin />}
                            label='Meter Conn. Date'
                            handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'meter_conn_date' })}
                            name='meter_conn_date'
                            handleBlur={handleBlur}
                            value={values.meter_conn_date}
                            error={errors.meter_conn_date}
                            touched={touched.meter_conn_date}
                            placeholder='XXXX/XX/XX'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label="Marga/Tole"
                            options={toleOptions}
                            name='marga_tole'
                            required={false}
                            placeholder='Select Active User'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'marga_tole' } });
                            }}
                            isLoading={loading}
                            value={values.marga_tole}
                            touched={touched.marga_tole}
                            errors={errors.marga_tole}
                        />
                    </Grid>

                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Meter Reading Zone'
                            name='meter_reading_zone'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.meter_reading_zone}
                            error={errors.meter_reading_zone}
                            touched={touched.meter_reading_zone}
                            placeholder='Enter Meter Reading Zone'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Serial No.'
                            name='serial_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.serial_no}
                            error={errors.serial_no}
                            touched={touched.serial_no}
                            placeholder='Enter Serial No'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Meter Serial No.'
                            name='meter_sn'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.meter_sn}
                            error={errors.meter_sn}
                            touched={touched.meter_sn}
                            placeholder='Enter Meter Serial No'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Serial Suffix'
                            name='serial_suffix'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.serial_suffix}
                            error={errors.serial_suffix}
                            touched={touched.serial_suffix}
                            placeholder='Enter Serial Suffix'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            prefix={<PiNumberCircleNineThin />}
                            label='Area No.'
                            name='area_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.area_no}
                            error={errors.area_no}
                            touched={touched.area_no}
                            placeholder='Area No.'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='Meter Status'
                            options={MeterStatusOptions}
                            name='meter_status'
                            required={false}
                            placeholder='Select meter status'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'meter_status' } });
                            }}
                            value={values.meter_status}
                            touched={touched.meter_status}
                            errors={errors.meter_status}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='Customer Type'
                            options={MemberTypeOptions}
                            name='customer_type'
                            required={false}
                            placeholder='Select Ccustomer type'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'customer_type' } });
                            }}
                            value={values.customer_type}
                            touched={touched.customer_type}
                            errors={errors.customer_type}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='Meter Type'
                            options={MeterTypeOptions}
                            name='meter_type'
                            required={false}
                            placeholder='Meter Type'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'meter_type' } });
                            }}
                            value={values.meter_type}
                            touched={touched.meter_type}
                            errors={errors.meter_type}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='Tap Type'
                            options={TapTypeOptions}
                            name='tap_type'
                            required={false}
                            placeholder='Tap Type'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'tap_type' } });
                            }}
                            value={values.tap_type}
                            touched={touched.tap_type}
                            errors={errors.tap_type}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='Tap Size'
                            options={tapSizeOptions}
                            name='tap_size'
                            required={false}
                            placeholder='Tap Size'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'tap_size' } });
                            }}
                            isLoading={loading}
                            value={values.tap_size}
                            touched={touched.tap_size}
                            errors={errors.tap_size}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            prefix={<PiNumberCircleNineThin />}
                            label='Discount Unit'
                            name='discount_unit'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.discount_unit}
                            error={errors.discount_unit}
                            touched={touched.discount_unit}
                            placeholder='Discount Unit'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            prefix={<PiNumberCircleNineThin />}
                            label='Tap No'
                            name='tap_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.tap_no}
                            error={errors.tap_no}
                            touched={touched.tap_no}
                            placeholder='Enter tap no.'
                            required={false} />
                    </Grid>

                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='Reader'
                            options={readerOptions}
                            name='reader'
                            required={false}
                            placeholder='Select reader'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'reader' } });
                            }}
                            isLoading={loading}
                            value={values.reader}
                            touched={touched.reader}
                            errors={errors.reader}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Reading Day'
                            name='reading_day'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.reading_day}
                            error={errors.reading_day}
                            touched={touched.reading_day}
                            placeholder='1-31'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Registration Date'
                            name='reg_date_n'
                            handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'reg_date_n' })}
                            handleBlur={handleBlur}
                            value={values.reg_date_n}
                            error={errors.reg_date_n}
                            touched={touched.reg_date_n}
                            placeholder='XXXX/XX/XX'
                            required={false}
                        />
                    </Grid>

                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Reading Effective'
                            name='reading_effective'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.reading_effective}
                            error={errors.reading_effective}
                            touched={touched.reading_effective}
                            placeholder='Reading Effective '
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='No Of customers'
                            name='consumers_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.consumers_no}
                            error={errors.consumers_no}
                            touched={touched.consumers_no}
                            placeholder='No. Of Consumers'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='EMI'
                            options={YesNoOptions}
                            name='emi'
                            required={true}
                            placeholder='Select EMI'
                            optionSelect={(name, selectedOption) => {
                                setOnEmi((prevState) => ({
                                    ...prevState, // Spread the previous state to preserve existing values
                                    open: selectedOption.value === "1" // Update only the `open` property
                                }));
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'emi' } });
                            }}
                            value={values.emi}
                            touched={touched.emi}
                            errors={errors.emi}

                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <SelectInputBox
                            label='Tap Status'
                            options={TapStatusOptions}
                            name='tap_status'
                            required={false}
                            placeholder='Select tap status'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'tap_status' } });
                            }}
                            value={values.tap_status}
                            touched={touched.tap_status}
                            errors={errors.tap_status}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Sadhiyar No'
                            name='sadhiyar_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.sadhiyar_no}
                            error={errors.sadhiyar_no}
                            touched={touched.sadhiyar_no}
                            placeholder='Sadhiyar No.'
                            required={false}
                        />
                    </Grid>
                </Grid>
                <AppSpace />
                <SecHeading type='add' icon={<PiIslandLight />} label='Land Details' />
                <Grid container columnSpacing={2} rowSpacing={1}>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Naksha No'
                            name='nak_sa_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.nak_sa_no}
                            error={errors.nak_sa_no}
                            placeholder='Naksha No'
                            touched={touched.nak_sa_no}
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Kitta No'
                            name='kitta_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.kitta_no}
                            error={errors.kitta_no}
                            placeholder='Kitta No'
                            touched={touched.kitta_no}
                            required={false} />
                    </Grid>

                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Area of Land'
                            name='area_land'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.area_land}
                            placeholder='Area of Land'
                            error={errors.area_land}
                            touched={touched.area_land}
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<TbHexagonNumber2 />}
                            label='House No.'
                            name='house_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.house_no}
                            placeholder='House No.'
                            error={errors.house_no}
                            touched={touched.house_no}
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Purja No.'
                            name='purja_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.purja_no}
                            error={errors.purja_no}
                            placeholder='Purja No.'
                            touched={touched.purja_no}
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Area Supply No.'
                            name='area_supply'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.area_supply}
                            error={errors.area_supply}
                            placeholder='Area Supply No.'
                            touched={touched.area_supply}
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            prefix={<GiAscendingBlock />}
                            label='Block No.'
                            name='block_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.block_no}
                            error={errors.block_no}
                            touched={touched.block_no}
                            placeholder='Enter Block No.'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Ferrule Meter Distance'
                            name='ferrule_meter_distance'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.ferrule_meter_distance}
                            error={errors.ferrule_meter_distance}
                            touched={touched.ferrule_meter_distance}
                            placeholder='Ferrule Meter Distance'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Ground Level Ferrule'
                            name='ground_level_ferrule'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.ground_level_ferrule}
                            error={errors.ground_level_ferrule}
                            touched={touched.ground_level_ferrule}
                            placeholder='Ground Level Ferrule'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<GiPathDistance />}
                            label='Distance'
                            name='distance'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.distance}
                            error={errors.distance}
                            touched={touched.distance}
                            placeholder='Enter distance'
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Mian Pipe Size'
                            name='mian_pipe_size'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.mian_pipe_size}
                            error={errors.mian_pipe_size}
                            touched={touched.mian_pipe_size}
                            placeholder='Enter mian pipe size'
                            required={false} />
                    </Grid>

                </Grid>
                <AppSpace />
                <SecHeading type='add' icon={<IoDocumentsOutline />} label='Documents' />
                <Grid container columnSpacing={2} rowSpacing={1}>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <FileTextBox
                            type='file'
                            label='Citizenship Photo'
                            name='citz_photo'
                            handleBlur={handleBlur}
                            ref={(el) => (fileInputRefs.current['citz_photo'] = el)}
                            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setFieldValue("citz_photo", file); // Handle the file change correctly
                                }
                            }}
                            error={errors.citz_photo}
                            touched={touched.citz_photo}
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <FileTextBox
                            type='file'
                            label='Photo'
                            name='photo'
                            handleBlur={handleBlur}
                            ref={(el) => (fileInputRefs.current['photo'] = el)}

                            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setFieldValue("photo", file); // Handle the file change correctly
                                }
                            }}
                            error={errors.photo}
                            touched={touched.photo}
                            required={false} />
                    </Grid>

                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <FileTextBox
                            type='file'
                            label='Thub Print Left/Right'
                            name='thumb_photo'
                            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setFieldValue("thumb_photo", file); // Handle the file change correctly
                                }
                            }}
                            ref={(el) => (fileInputRefs.current['thumb_photo'] = el)}

                            handleBlur={handleBlur}
                            error={errors.thumb_photo}
                            touched={touched.thumb_photo}
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <FileTextBox
                            type='file'
                            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setFieldValue("signature1", file); // Handle the file change correctly
                                }
                            }}
                            ref={(el) => (fileInputRefs.current['signature1'] = el)}
                            label='Signature'
                            name='signature1'
                            handleBlur={handleBlur}
                            error={errors.signature1}
                            touched={touched.signature1}
                            required={false} />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={4} xs={12}>
                        <FileTextBox
                            type='file'
                            label='Lal Purja'
                            name='lal_purja'
                            ref={(el) => (fileInputRefs.current['lal_purja'] = el)}
                            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setFieldValue("lal_purja", file); // Handle the file change correctly
                                }
                            }}
                            handleBlur={handleBlur}
                            error={errors.lal_purja}
                            touched={touched.lal_purja}
                            required={false}
                        />


                    </Grid>

                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={10}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>
        </Container>
    )
}

export default ConsumerAddFormView;
